import { defineMessages } from 'react-intl';

const messages = defineMessages({
  yes: {
    id: 'app.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'app.no',
    defaultMessage: 'No',
  },
  areYouSure: {
    id: 'app.are-you-sure',
    defaultMessage: 'Are you sure?',
  },
  cancel: {
    id: 'app.cancel',
    defaultMessage: 'Cancel',
  },
  enable: {
    id: 'app.enable',
    defaultMessage: 'Enable',
  },
  enabled: {
    id: 'app.enabled',
    defaultMessage: 'Enabled',
  },
  activate: {
    id: 'app.activate',
    defaultMessage: 'Activate',
  },
  noThanks: {
    id: 'app.no-thanks',
    defaultMessage: 'No thanks',
  },
  required: {
    id: 'app.required',
    defaultMessage: 'Required',
  },
  optional: {
    id: 'app.optional',
    defaultMessage: 'Optional',
  },
  recommended: {
    id: 'app.recommended',
    defaultMessage: 'Recommended',
  },
  save: {
    id: 'app.save',
    defaultMessage: 'Save',
  },
  submit: {
    id: 'app.submit',
    defaultMessage: 'Submit',
  },
  close: {
    id: 'app.close',
    defaultMessage: 'Close',
  },
  closeMenuAriaLabel: {
    id: 'app.close-menu.aria-label',
    defaultMessage: 'Close Menu',
  },
  left: {
    id: 'app.left-direction',
    defaultMessage: 'Left',
  },
  right: {
    id: 'app.right-direction',
    defaultMessage: 'Right',
  },
  classpass: {
    id: 'app.classpass',
    defaultMessage: 'ClassPass',
  },
  learnMore: {
    id: 'app.learn-more',
    defaultMessage: 'Learn more',
  },
  delete: {
    id: 'app.delete',
    defaultMessage: 'Delete',
  },
  start: {
    id: 'app.start',
    defaultMessage: 'Start',
  },
  end: {
    id: 'app.end',
    defaultMessage: 'End',
  },
  type: {
    id: 'app.type',
    defaultMessage: 'Type',
  },
  all: {
    id: 'app.all',
    defaultMessage: 'All',
  },
  day: {
    id: 'app.day',
    defaultMessage: 'Day',
  },
  week: {
    id: 'app.week',
    defaultMessage: 'Week',
  },
});

export default messages;
